import { CommonBody } from "types/General";
import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";
import { User } from "types/User";

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

export const userApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllUsers: builder.query<
      CommonResponse & { data: User },
      { page: number; search: string; startDate?: any; endDate?: any }
    >({
      query: ({ page, search, startDate, endDate }) => {
        const params = new URLSearchParams({
          page: page.toString(),
          search,
        });

        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);

        return {
          url: `${END_POINTS.users}?${params.toString()}`,
          method: "GET",
        };
      },
    }),

    userDetails: builder.query<
      CommonResponse & { data: User },
      { id: string | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.users}/${id}`,
        method: "GET",
      }),
    }),

    changeUserStatus: builder.mutation<
      CommonResponse & { data: User },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.changeUserStatus}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    updateUser: builder.mutation<
      CommonResponse & { data: User },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.users}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    deleteUser: builder.query<
      CommonResponse & { data: User },
      { id: string | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.users}/${id}`,
        method: "DELETE",
      }),
    }),

    exportCsv: builder.query<CommonResponse & { data: any }, {}>({
      query: ({}) => ({
        url: `${END_POINTS.users}?export=csv`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLazyGetAllUsersQuery,
  useChangeUserStatusMutation,
  useLazyUserDetailsQuery,
  useUpdateUserMutation,
  useDeleteUserQuery,
  useLazyExportCsvQuery,
} = userApi;
